/**
 * A bit of JS to detect dark mode and change the favicon accordingly
 * @see https://web.dev/prefers-color-scheme/#reacting-on-dark-mode-changes
 */

class FaviconTheme {
  constructor() {
    this.darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.isDarkModeOn = this.darkModeMediaQuery.matches;

    this.manifests = document.querySelectorAll('link[rel="manifest"]');
    this.favicons = document.querySelectorAll('link[rel="icon"]');
    this.appleIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');

    this.init();
  }

  init() {
    if (window.matchMedia('(prefers-color-scheme)').media === 'not all') {
      return;
    }
    this.toggleTheme(this.isDarkModeOn);
    this.darkModeMediaQuery.addListener(e => this.toggleTheme(e.matches));
  }

  /**
   * Set hrefs of <link> elements depending on dark mode
   */
  toggleTheme(isDarkMode) {
    const setHref = link => {
      link.href = isDarkMode ? link.dataset.hrefDark : link.dataset.hrefLight;
    };

    this.manifests.forEach(link => setHref(link));
    this.favicons.forEach(link => setHref(link));
    this.appleIcons.forEach(link => setHref(link));
  }
}

export default FaviconTheme;
